import styled from 'styled-components';
import { maxMediaQueries, minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { grid } from '@finect/tabular-utils/grid';
import { VideoPlayer } from './VideoPlayer';
import { fadeInRule, fadeOutRule, slideInRule } from './keyframes';

export const VideoHeroPlayer = styled(VideoPlayer)`
  ${minMediaQueries.tablet`
    position: ${({ small }) => (small ? 'fixed' : 'absolute')};
    z-index: ${({ small }) => (small ? '2' : 'auto')};
    top: ${({ small }) => (small ? 'auto' : 0)};
    bottom: ${({ small }) => (small ? '30px' : 'auto')};
    left: ${({ small }) => (small ? 'auto' : 0)};
    right: ${({ small }) => (small ? '30px' : 0)};
    width: ${({ small }) => (small ? `${grid(4)}px` : '100%')};
    height: ${({ small }) => (small ? `240px` : '100%')};
    ${({ small }) => (small ? `backface-visibility: hidden;` : null)};
    animation: ${({ small, transitionSmall, transitionBig }) =>
    (small && !transitionSmall && !transitionBig
      ? `${fadeInRule}`
      : transitionSmall
        ? `${fadeOutRule}`
        : transitionBig
          ? `${slideInRule}`
          : null)};
    animation-fill-mode: ${({ transitionSmall }) => (transitionSmall ? 'forwards' : 'none')};
  `};

  svg {
    width: 120px;
    margin-top: -60px;
    margin-left: -60px;

    ${minMediaQueries.tablet`
      z-index: ${({ small }) => (small ? '1' : 'auto')};
      width: ${({ small }) => (small ? '72px' : '120px')};
      margin-top: ${({ small }) => (small ? '-36px' : '-60px')};
      margin-left: ${({ small }) => (small ? '-36px' : '-60px')};
    `};

    ${maxMediaQueries.phone`
      width: 72px;
      margin-top: -36px;
      margin-left: -36px;
    `};

    /* stylelint-disable */
    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      margin-top: 0;
    }
    /* stylelint-enable */
  }
`;
